import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll to the top whenever the route changes so every new
// screen starts at the top instead of inheriting the previous scroll position.
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
